import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import GetAllSports from "../../../../Controllers/Common/GetAllSports";
import GetUser from "../../../../Controllers/Users/GetUser";

export default function SportsListingViewModel() {
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [AuthUser, setAuthUser] = useState();
  const [SportsArray, setSportsArray] = useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const SchoolsData = await GetAllSports(SchoolID);
      setSportsArray(SchoolsData);
      setIsLoading(false);
    }
    fetchData();
  }, [SchoolID]);

  return {
    SportsArray,
    AuthUser,
    IsLoading,
  };
}
